/* ==========================================================================
   ZWANZE — variant-picker.js
   Sélection de variante sans rechargement. Met à jour prix, disponibilité,
   URL et bouton. Les tailles indisponibles restent visibles et barrées.
   ========================================================================== */
(function () {
  'use strict';
  const Z = window.Zwanze;
  if (!Z) return;

  class VariantPicker extends HTMLElement {
    connectedCallback() {
      const data = this.querySelector('[data-variants]');
      if (!data) return;
      this.variants = JSON.parse(data.textContent);

      // Correspondance variante -> photo de la galerie, ecrite par
      // sections/main-product.liquid. Absente ou illisible : on continue
      // sans elle, la selection de variante reste fonctionnelle.
      this.variantMedia = {};
      const mediaMap = this.querySelector('[data-variant-media]');
      if (mediaMap) {
        try { this.variantMedia = JSON.parse(mediaMap.textContent); } catch (e) { this.variantMedia = {}; }
      }

      this.addEventListener('change', this._onChange.bind(this));
      this._paintAvailability();
    }

    get selectedOptions() {
      return Array.from(this.querySelectorAll('input[type="radio"]:checked')).map((input) => input.value);
    }

    _match(options) {
      return this.variants.find(function (variant) {
        return options.every(function (value, index) { return variant.options[index] === value; });
      });
    }

    _onChange() {
      const variant = this._match(this.selectedOptions);
      this._paintAvailability();
      this._paintLabels();
      if (!variant) return this._setUnavailable();

      this._setVariant(variant);
      if (this.dataset.url) {
        window.history.replaceState({}, '', this.dataset.url + '?variant=' + variant.id);
      }
    }

    /* Une valeur d'option est marquée indisponible si aucune variante
       ne la combine avec les autres choix déjà faits. */
    _paintAvailability() {
      const chosen = this.selectedOptions;
      this.querySelectorAll('[data-option-index]').forEach((group) => {
        const index = Number(group.dataset.optionIndex);
        group.querySelectorAll('input[type="radio"]').forEach((input) => {
          const test = chosen.slice();
          test[index] = input.value;
          const found = this.variants.find(function (variant) {
            return test.every(function (value, i) { return i === index ? variant.options[i] === value : variant.options[i] === value; })
              && variant.available;
          });
          const label = group.querySelector('label[for="' + input.id + '"]');
          if (label) label.classList.toggle('is-unavailable', !found);
        });
      });
    }

    _paintLabels() {
      this.querySelectorAll('[data-option-index]').forEach((group) => {
        const index = group.dataset.optionIndex;
        const checked = group.querySelector('input:checked');
        const output = this.querySelector('[data-selected-for="' + index + '"]');
        if (output && checked) output.textContent = checked.value;
      });
    }

    /* Ajout (Claude) : la photo suit la couleur.
       C'est ce qui manquait — on cochait « Kaki » et l'image ne bougeait pas,
       donc choisir une couleur ne servait visiblement a rien. Chaque variante
       porte sa photo dans Shopify (featured_media) ; on demande simplement a
       la galerie de venir dessus. Si la variante n'a pas de photo propre, on
       ne touche a rien plutot que de sauter sur une image au hasard. */
    _showVariantMedia(variant) {
      const mediaId = this.variantMedia && this.variantMedia[variant.id];
      if (!mediaId) return;
      const gallery = document.querySelector('z-media-gallery');
      if (!gallery || typeof gallery.goToMediaId !== 'function') return;
      gallery.goToMediaId(mediaId);
    }

    _setVariant(variant) {
      const idField = this.querySelector('[data-variant-id]');
      if (idField) idField.value = variant.id;

      this._showVariantMedia(variant);

      const price = document.querySelector('[data-price]');
      if (price) price.textContent = Z.formatMoney(variant.price);

      const stickyPrice = document.querySelector('[data-sticky-price]');
      if (stickyPrice) stickyPrice.textContent = Z.formatMoney(variant.price);

      const button = this.querySelector('[data-add-button]');
      const text = this.querySelector('[data-add-text]');
      if (button) button.disabled = !variant.available;
      if (text) text.textContent = variant.available ? Z.strings.addToCart : Z.strings.soldOut;
    }

    _setUnavailable() {
      const button = this.querySelector('[data-add-button]');
      const text = this.querySelector('[data-add-text]');
      if (button) button.disabled = true;
      if (text) text.textContent = Z.strings.unavailable;
    }
  }
  customElements.define('z-variant-picker', VariantPicker);

  /* --- Barre d'achat collante : n'apparaît qu'une fois le bouton principal
         sorti de l'écran. Elle ne double jamais un bouton déjà visible. --- */
  document.addEventListener('DOMContentLoaded', function () {
    const primary = document.querySelector('[data-add-button]');
    const sticky = document.querySelector('[data-sticky-buy]');
    if (!primary || !sticky) return;

    sticky.hidden = false;
    new IntersectionObserver(function (entries) {
      sticky.toggleAttribute('data-visible', !entries[0].isIntersecting);
    }, { rootMargin: '-80px 0px 0px 0px' }).observe(primary);

    const stickyAdd = sticky.querySelector('[data-sticky-add]');
    if (stickyAdd) {
      stickyAdd.addEventListener('click', function () {
        primary.scrollIntoView({ block: 'center' });
        primary.click();
      });
    }
  });
})();
